module.exports = __webpack_public_path__ + "static/img/5_000.bb532e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp4/5_000.jpg
// module id = XJSC
// module chunks = 1